import { NoteVisibilityType } from '../../shared/enums';

export const visibilityGroups: NoteVisibilityType[] = [
  NoteVisibilityType.User,
  NoteVisibilityType.UserGroup,
  NoteVisibilityType.General,
];
export const defaultVisibilityGroup: NoteVisibilityType =
  NoteVisibilityType.User;
